<script>
    import { getContext } from "svelte";
    import { scale } from "svelte/transition";

    import { TOASTS_KEY } from "./toast";

    export let toast;

    const { removeToast } = getContext(TOASTS_KEY);

    $: timed = toast.duration !== undefined;

    function handleDismiss() {
        removeToast(toast.id);
    }
</script>

<div
    class="root {toast.kind}"
    style="--duration: {toast.duration}ms"
    transition:scale={{ duration: 250, start: 0.8 }}
>
    <div class="progress" class:timed on:animationend={handleDismiss} />
    <div class="content-container hstack centered nowrap">
        {#if toast.waiting}
            <div class="spinner" />
        {/if}
        <div class="content">
            {#if toast.escape}
                {toast.content}
            {:else}
                {@html toast.content}
            {/if}
        </div>
        <div class="dismiss" on:click={handleDismiss}>Dismiss</div>
    </div>
</div>

<style>
    .root.default {
        --front-color: var(--app-fg-color);
        --back-color: var(--app-placeholder-color);
        --color: var(--app-bg-color);
    }

    .root.info {
        --front-color: #25f;
        --back-color: #2f458d;
        --color: #fff;
    }

    .root.warn {
        --front-color: #fc2;
        --back-color: #b4911d;
        --color: #000;
    }

    .root.success {
        --front-color: #282;
        --back-color: #1b4e1b;
        --color: #fff;
    }

    .root.error {
        --front-color: #d33;
        --back-color: #922121;
        --color: #fff;
    }

    .root {
        color: var(--color);
        background-color: var(--back-color);
        border-radius: 20px;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1),
            0 2px 15px 0 rgba(0, 0, 0, 0.05);
    }

    .progress {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--front-color);
        z-index: 5;
    }

    .progress.timed {
        animation-name: progress-width;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-duration: var(--duration);
        animation-play-state: running;
    }

    .root:hover .progress.timed {
        animation-play-state: paused;
    }

    @keyframes progress-width {
        from {
            width: 100%;
        }
        to {
            width: 0%;
        }
    }

    .content-container {
        position: relative;
        z-index: 10;
    }

    .content {
        padding: 10px 15px 10px 20px;
    }

    .separator {
        width: 2px;
        height: 100%;
        background-color: var(--color);
    }

    .dismiss {
        padding: 10px 20px 10px 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: solid 2px var(--color);
    }

    .dismiss:focus,
    .dismiss:hover {
        background-color: var(--color);
        color: var(--front-color);
    }

    .spinner {
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        border: 3px solid;
        border-radius: 100%;
        border-color: #aaa;
        border-right-color: var(--color);
        animation: spin 0.65s linear infinite;
        margin: 0px -5px 0px 10px;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
